import React, { useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useNavigate } from 'react-router-dom'
import { authService } from '../../common/service/auth.service'
import { Card, Button, Input, Typography, Row, Col, Space } from 'antd'
import OrganizationLogo from '../../common/components/Logo/OrganizationLogo'
import { FcManager } from 'react-icons/fc'
import { RiLockPasswordFill } from 'react-icons/ri'
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai'
import { useTheme, useThemeColors } from '../../common/ThemeContext'

const { Title, Text } = Typography
const ManagerIcon = FcManager as unknown as React.ComponentType<{ size?: number }>
const PasswordIcon = RiLockPasswordFill as unknown as React.ComponentType<{ size?: number }>
const EyeIcon = AiFillEye as unknown as React.ComponentType
const EyeInvisibleIcon = AiFillEyeInvisible as unknown as React.ComponentType

function LoginForm() {
	const { primary } = useThemeColors()
	const { isDarkMode } = useTheme()
	const inputTextColor = isDarkMode ? 'rgba(248, 250, 252, 0.92)' : '#333'
	const [loading, setLoading] = useState(false)
	const [showPassword, setShowPassword] = useState(false)
	const handleClick = () => setShowPassword(!showPassword)
	const [formData, setFormData] = useState({
		email: '',
		password: '',
	})
	const { email, password } = formData

	const navigate = useNavigate()

	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		e.preventDefault()
		setFormData((prevState) => ({
			...prevState,
			[e.target.id]: e.target.value,
		}))
	}

	const onSubmit = async (e: React.FormEvent) => {
		e.preventDefault()

		try {
			setLoading(true)
			const response = await authService.login(email, password)

			console.log('📨 Login response received:', response)

			// Check if token was successfully stored
			const token = authService.getToken()

			if (token) {
				toast.success('Login successful!')
				navigate('/welcome')
			} else {
				console.error('❌ No token stored after login. Response:', response)
				toast.error('Login failed. Invalid response from server.')
				setLoading(false)
			}
		} catch (error: any) {
			console.error('❌ Login error:', error)
			const errorMessage =
				error?.response?.data?.message || 'Login failed. Please check your credentials!'
			toast.error(errorMessage)
			setLoading(false)
		}
	}

	return (
		<>
			<Card
				style={{
					margin: '20px auto',
					maxWidth: '400px',
					textAlign: 'center',
					boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
					borderRadius: '8px',
				}}
			>
				<div style={{ marginBottom: '20px' }}>
					<OrganizationLogo />
				</div>
				<Title
					level={4}
					style={{
						fontFamily: 'Times New Roman',
						marginBottom: '20px',
						color: primary,
					}}
				>
					Attendance Management System
				</Title>
				<form onSubmit={onSubmit}>
					<Space direction='vertical' style={{ width: '100%' }} size='large'>
						<Row align='middle' gutter={[8, 8]}>
							<Col span={2}>
								<ManagerIcon size={24} />
							</Col>
							<Col span={22}>
								<Input
									type='email'
									placeholder='Email'
									id='email'
									value={email}
									onChange={onChange}
									size='large'
									style={{ fontFamily: 'Times New Roman', color: inputTextColor }}
								/>
							</Col>
						</Row>

						<Row align='middle' gutter={[8, 8]}>
							<Col span={2}>
								<PasswordIcon size={24} />
							</Col>
							<Col span={22}>
								<Input.Password
									placeholder='Password'
									id='password'
									value={password}
									onChange={onChange}
									size='large'
									style={{ fontFamily: 'Times New Roman', color: inputTextColor }}
									iconRender={(visible) =>
										visible ? <EyeIcon /> : <EyeInvisibleIcon />
									}
								/>
							</Col>
						</Row>

						<Button
							type='primary'
							htmlType='submit'
							loading={loading}
							style={{
								backgroundColor: primary,
								borderColor: primary,
								width: '100%',
								fontFamily: 'Times New Roman',
								fontSize: '16px',
								color: '#fff',
							}}
							disabled={!email || !password}
						>
							Sign In
						</Button>
					</Space>
					<ToastContainer position='top-center' autoClose={6000} theme='colored' />
				</form>
			</Card>
		</>
	)
}

export default LoginForm
